import { Box, Stack, FieldLabel, FieldMessage } from 'braid-design-system';
import type { ReactNode } from 'react';

interface CheckoutFormFieldProps {
  id: string;
  label: string;
  error?: string;
  children: ReactNode;
}

export const CheckoutFormField = (props: CheckoutFormFieldProps) => (
  <Stack space="small">
    <FieldLabel htmlFor={props.id} label={props.label} />

    <Stack space="xsmall">
      <Box id={props.id}>{props.children}</Box>

      {Boolean(props.error) && (
        <FieldMessage
          id={`${props.id}-error`}
          tone="critical"
          message={props.error}
        />
      )}
    </Stack>
  </Stack>
);
